module.exports = __webpack_public_path__ + "2a6c6ebfe03ccbcf0ce58e26e103a9f4.jpg";